const statusStyles = {
  neutral: 'bg-surface-sunken text-ink-soft border-border-default',
  accent:  'bg-accent-tint text-accent border-accent-border',
  success: 'bg-success-tint text-success border-success-border',
  warning: 'bg-warning-tint text-warning border-warning-border',
  danger:  'bg-danger-tint text-danger border-danger-border',
  info:    'bg-info-tint text-info border-info-border',
};

export default function Badge({ children, status = 'neutral', className = '' }) {
  return (
    <span
      className={`
        inline-flex items-center gap-1 px-2.5 py-0.5
        rounded-pill text-label uppercase border
        ${statusStyles[status]} ${className}
      `}
    >
      {children}
    </span>
  );
}
